import React, { Component } from 'react'

import Dico from '../../helpers/Dico'
import Teaser from './Teaser'
import TextWithFieldname from '../texts/TextWithFieldname';
import BottomTexts from './BottomTexts';
import ContDetails from '../../containers/ContDetails';
import ContFinanceFile from '../../containers/ContFinanceFile';
import ContCalculator from '../../containers/ContCalculator';
import Disclaimer from './Disclaimer';
import helperTeaser from '../../helpers/HelperTeaser';
import HelperWidget from '../../helpers/HelperWidget';

class ResultSummary extends Component {

	constructor(props) {
		super(props);
		this.state = { calcOpen: null, selectedVehicle: props.vehicle };
	}

	handleParamChange(data, widgetParameters, customer) {
		this.props.onChangeParameters(data, widgetParameters, customer);
	}

	handleOpenCalculator(vehicle) {
		this.setState({ selectedVehicle: { ...vehicle, configurationKey: undefined }, calcOpen: true });
	}

	checkOutputWidget(data) {
		if (data != null) {
			this.handleParamChange(data.parameters, data.widgetParameters);
		}
		this.props.onOpenWidget(false);
	}

	occRenvoiGlob = 1;
	render() {
		const developperView = this.props.settings.isDevelopperView;
		const fastPlugCurrentDate = this.props.settings.fastPlugCurrentDate;
		
		const openWidget = HelperWidget.initWidget(
			{
				context:  {...this.props.context, fastPlugCurrentDate: fastPlugCurrentDate}, 
				parameters: this.props.parameters,
				parametersForFetch: this.props.parametersForFetch,
				widgetParameters: this.props.widgetParameters, 
				partExchange: this.props.partExchange,
				isDebugMode: !!developperView,
			},
			this.props.settings, this.props.env,
			this.props.widgetState,
			this.props.onOpenWidget, (data) => { this.checkOutputWidget(data) });
		this.occRenvoiGlob = 1;
		var disclaimer = null;
		if (typeof this.props.responseSimulation !== 'undefined' && typeof this.props.responseSimulation.vehiclesRental !== 'undefined'
			&& typeof this.props.responseSimulation.vehiclesRental.disclaimer !== 'undefined') {
			disclaimer = this.props.responseSimulation.vehiclesRental.disclaimer;
		} else if (this.props.responseSimulation && this.props.responseSimulation.vehicleDetails && this.props.responseSimulation.vehicleDetails.result) {
			disclaimer = this.props.responseSimulation.vehicleDetails.result.disclaimer;
		}
		return (
			<div className='text-start overflow-y-auto'>
				<Disclaimer disclaimer={disclaimer} developperView={developperView} />
				{this.props.responseSimulation && this.props.settings.process !== 'vehiclesConfig'
					&& this.props.settings.process !== 'vehiclesStock' && this.props.settings.process !== 'vehiclesDefault'
					&& this.props.responseSimulation.vehicleDetails
					&& this.props.responseSimulation.vehicleDetails.result
					&& <Teaser
						teaser={this.props.responseSimulation.vehicleDetails.result.teaser}
						disclaimer={this.props.responseSimulation.vehicleDetails.result.disclaimer}
						context={this.props.context}
						vehicle={this.props.vehicle}
						env={this.props.env}
						settings={this.props.settings}
						onCalcOpen={() => this.handleOpenCalculator(this.props.vehicle)}
						onWidgetOpen={() => { openWidget(this.props.vehicle) }/*() => openWidget(this.props.vehicle)*/}
						reloadWidget={HelperWidget.getInstanceWidgetReloadFunction(this.props.settings,this.props.onReloadWidget)}
						vehicleDetails={this.props.responseSimulation.vehicleDetails}
						occRenvoi={this.returnReference(helperTeaser.getNbOccRenvoi(this.props.responseSimulation.vehicleDetails.result.teaser))}
						responseObject={this.props.responseSimulation.vehicleDetails}
					/>
				}
				{(this.props.settings.process === 'vehiclesConfig' || this.props.settings.process === 'vehiclesStock' || this.props.settings.process === 'vehiclesDefault')
					&& this.props.responseSimulation && this.props.responseSimulation.vehiclesRental != null
					&&
					<div>
						{this.props.responseSimulation.vehiclesRental.globalNotice != null &&
							<TextWithFieldname fieldname="globalNotice" developperView={this.props.settings.isDevelopperView} variant="subtitle1">
								{this.props.responseSimulation.vehiclesRental.globalNotice}
							</TextWithFieldname>
						}
						{this.props.responseSimulation.vehiclesRental.vehicleResults
							&& this.props.responseSimulation.vehiclesRental.vehicleResults.map((line, index) => (
								<Teaser
									key={index}
									teaser={line.teaser}
									context={this.props.context}
									vehicle={line.vehicle}
									env={this.props.env}
									settings={this.props.settings}
									onCalcOpen={() => this.handleOpenCalculator(line.vehicle)}
									onWidgetOpen={() => { openWidget(line.vehicle) }/*() => openWidget(line.vehicle)*/}
									reloadWidget={HelperWidget.getInstanceWidgetReloadFunction(this.props.settings, this.props.onReloadWidget)}
									occRenvoi={this.returnReference(helperTeaser.getNbOccRenvoi(line.teaser))}
									responseObject={line}
								/>
							))}
					</div>
				}
				{this.props.settings.process === 'options'
					&& this.props.responseSimulation && this.props.responseSimulation.optionsRental != null
					&& this.props.responseSimulation.optionsRental.optionsResults != null
					&&
					<div>
						{this.props.responseSimulation.optionsRental.globalNotice != null &&
							<h3>
								{this.props.responseSimulation.optionsRental.globalNotice}
							</h3>
						}
						{this.props.responseSimulation.optionsRental.optionsResults.map((line, index) => (
							<h5 key={index}>
								<div className='row shadow'>
									<div className='col'>{line.code}</div>
									<div className='col'>
										{Dico.getIncrementAmountPerMonthFormatted(line.priceAdjustment, this.props.responseSimulation?.optionsRental?.renderAmountNature ?? "TC", this.props.context.countryCode,
											this.props.context.languageCode)}
									</div>
									{this.props.responseSimulation.optionsRental.globalPrecision &&
										<div className='col'>*</div>
									}
								</div>
							</h5>
						))}
					</div>
				}
				{this.props.settings.process === 'accessories'
					&& this.props.responseSimulation && this.props.responseSimulation.accessoriesIncrease != null
					&& this.props.responseSimulation.accessoriesIncrease.results != null
					&&
					<div>
						{this.props.responseSimulation.accessoriesIncrease.globalNotice != null &&
							<h3>
								{this.props.responseSimulation.accessoriesIncrease.globalNotice}
							</h3>
						}
						{this.props.responseSimulation.accessoriesIncrease.results.map((line, index) => (
							<h5 key={index}>
								<div className='row shadow'>
									<div className='col'>{line.key}</div>
									<div className='col'>
										{Dico.getIncrementAmountPerMonthFormatted(line.increase, this.props?.responseSimulation?.accessoriesIncrease?.renderAmountNature ?? "TC",
										 this.props.context.countryCode, this.props.context.languageCode)}
									</div>
									{this.props.responseSimulation.accessoriesIncrease.globalPrecision &&
										<div className='col'>*</div>
									}
								</div>
							</h5>
						))}
					</div>
				}
				<BottomTexts
					responseSimulation={this.props.responseSimulation}
					context={this.props.context}
					process={this.props.settings.process}
					developperView={this.props.settings.isDevelopperView}
					amountNature={this.props.responseSimulation?.result?.teaser?.data?.renderAmountNature ?? "TC"}
					configurationKey={this.props.vehicle.configurationKey}
				/>
				<div className='modal' id='modalDetail' tabIndex="-1" aria-labelledby="modalDetailTitle">
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
							<ContDetails />
						</div>
					</div>
				</div>
				<ContCalculator
					onUpdate={(data, customer) => { this.handleParamChange(data, null, customer) }}
				/>
				<ContFinanceFile />
			</div>
		)
	}


	returnReference(nb) {
		const occRenvoiIni = this.occRenvoiGlob;
		this.occRenvoiGlob += nb;
		return occRenvoiIni;
	}
}

export default (ResultSummary)

